module.exports = __webpack_public_path__ + "img/es.a62a83f3.svg";